import { benefits } from '@/mocks/categories';

export default function BenefitsSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-4">
            Why Choose Us
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Why Thousands Of Buyers Use Superbuy Sheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            From beginners to experienced international shoppers, our organized resources help everyone shop smarter.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group p-6 md:p-7 bg-background-50 border border-background-200/60 rounded-2xl hover:border-accent-300 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                <i className={`${benefit.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href="#categories"
            className="inline-flex items-center gap-2 px-7 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse All Categories
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}